import React from "react";
import StockExchangeSection from "../../components/Investor/StockExchange.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const StockExchange = () => {
  return (
    <div>
      <MetaComponent
        title="Filings with Stock Exchanges | Aptech Limited."
        desc="Discover Aptech's regulatory filings and stock exchange updates. Ensuring transparency and timely communication for investors and stakeholders."
        keywords="aptech stock exchanges, stock exchange update "
      />
      <StockExchangeSection />
    </div>
  );
};

export default StockExchange;
